// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.bg-soft-gradient {
  background: linear-gradient(
    to right,
    rgba(2, 71, 114, 0.7),
    rgba(1, 110, 49, 0.7)
  );
  border-radius: 1rem;
}

.bg-carousel-gradient {
  background: linear-gradient(
    to right,
    rgba(2, 71, 114, 0.2),
    rgba(1, 110, 49, 0.2)
  );
  border-radius: 0.5rem;
}

.animated-highlight {
  position: relative;
  color: #024772;
  background: linear-gradient(to right, #024772, #024772) no-repeat;
  background-size: 0 100%;
  padding: 0 0.5rem;
  border-radius: 12px;
  transition: color 1s ease-in-out;
  animation: highlight-animation 4s ease-in-out infinite alternate;
  display: inline-block;
  line-height: 1.3;
}

.animated-highlight::after {
  content: var(--animated-highlight-text, 'Process');
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: white;
  background-color: #024772;
  background-size: 100% 100%;
  border-radius: 12px;
  overflow: hidden;
  clip-path: inset(0 100% 0 0);
  animation: text-reveal 4s ease-in-out infinite alternate;
}

@keyframes highlight-animation {
  to {
    background-size: 100% 100%;
  }
}

@keyframes text-reveal {
  to {
    clip-path: inset(0 0 0 0);
  }
}

@keyframes spin-slow {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.animate-spin-slow {
  animation: spin-slow linear infinite;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.animate-scroll {
  display: flex;
  animation: scroll 30s linear infinite;
  width: calc(2 * 100%);
}

.animate-scroll:hover {
  animation-play-state: paused;
}

.pause {
  animation-play-state: paused;
}

/* carousel inicio */
@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.carousel-container {
  position: relative;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  animation: marquee 50s linear infinite;
  width: 200%;
}

.logo-item {
  transition: transform 0.3s ease-in-out;
}

.title-container {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}
/* carousel fin */

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-fade-in {
  animation: fadeIn 1s ease-out forwards;
}

.animate-slide-in {
  animation: slideIn 1s ease-out forwards;
}

.transition-opacity {
  transition: opacity 1s ease, transform 1s ease;
}

.testimonial-card {
  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.testimonial-card:hover {
  transform: scale(1.05);
  border-color: #024772;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

footer {
  width: 100%;
  margin: 0;
  padding: 0;
}

@media only screen and (max-width: 767px) {
  .carousel-track {
    animation: marquee 20s linear infinite;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;;;GAIC;EACD,mBAAmB;AACrB;;AAEA;EACE;;;;GAIC;EACD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iEAAiE;EACjE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gEAAgE;EAChE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA,iBAAiB;;AAEjB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.bg-soft-gradient {\n  background: linear-gradient(\n    to right,\n    rgba(2, 71, 114, 0.7),\n    rgba(1, 110, 49, 0.7)\n  );\n  border-radius: 1rem;\n}\n\n.bg-carousel-gradient {\n  background: linear-gradient(\n    to right,\n    rgba(2, 71, 114, 0.2),\n    rgba(1, 110, 49, 0.2)\n  );\n  border-radius: 0.5rem;\n}\n\n.animated-highlight {\n  position: relative;\n  color: #024772;\n  background: linear-gradient(to right, #024772, #024772) no-repeat;\n  background-size: 0 100%;\n  padding: 0 0.5rem;\n  border-radius: 12px;\n  transition: color 1s ease-in-out;\n  animation: highlight-animation 4s ease-in-out infinite alternate;\n  display: inline-block;\n  line-height: 1.3;\n}\n\n.animated-highlight::after {\n  content: var(--animated-highlight-text, 'Process');\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: white;\n  background-color: #024772;\n  background-size: 100% 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  clip-path: inset(0 100% 0 0);\n  animation: text-reveal 4s ease-in-out infinite alternate;\n}\n\n@keyframes highlight-animation {\n  to {\n    background-size: 100% 100%;\n  }\n}\n\n@keyframes text-reveal {\n  to {\n    clip-path: inset(0 0 0 0);\n  }\n}\n\n@keyframes spin-slow {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.animate-spin-slow {\n  animation: spin-slow linear infinite;\n}\n\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.animate-scroll {\n  display: flex;\n  animation: scroll 30s linear infinite;\n  width: calc(2 * 100%);\n}\n\n.animate-scroll:hover {\n  animation-play-state: paused;\n}\n\n.pause {\n  animation-play-state: paused;\n}\n\n/* carousel inicio */\n@keyframes marquee {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.carousel-container {\n  position: relative;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n}\n\n.carousel-track {\n  display: flex;\n  animation: marquee 50s linear infinite;\n  width: 200%;\n}\n\n.logo-item {\n  transition: transform 0.3s ease-in-out;\n}\n\n.title-container {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n/* carousel fin */\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 1s ease-out forwards;\n}\n\n.animate-slide-in {\n  animation: slideIn 1s ease-out forwards;\n}\n\n.transition-opacity {\n  transition: opacity 1s ease, transform 1s ease;\n}\n\n.testimonial-card {\n  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.testimonial-card:hover {\n  transform: scale(1.05);\n  border-color: #024772;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\nfooter {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .carousel-track {\n    animation: marquee 20s linear infinite;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
